import React from 'react';
import IconMenuStyled from './IconMenu.styled';

const IconMenu = props => (
  <IconMenuStyled viewBox="0 0 93 95" {...props}>
    <title>Return to menu</title>
    <path d="M24.5 11C15.4 11 8 18.4 8 27.5S15.4 44 24.5 44H41V27.5C41 18.4 33.6 11 24.5 11zM69.5 11C60.4 11 53 18.4 53 27.5V44h16.5C78.6 44 86 36.6 86 27.5S78.6 11 69.5 11zM8 72.5C8 81.6 15.4 89 24.5 89S41 81.6 41 72.5V56H24.5C15.4 56 8 63.4 8 72.5zM69.5 56H53v16.5C53 81.6 60.4 89 69.5 89S86 81.6 86 72.5 78.6 56 69.5 56z" />
  </IconMenuStyled>
);

export default IconMenu;



// WEBPACK FOOTER //
// ./src/components/atoms/IconMenu/IconMenu.js